<template>
  <v-app>
    <v-fade-transition mode="out-in">
      <div class="bg-image-container" v-if="!isAuthorized">
        <div class="bg-image" :style="{backgroundImage: 'url(\'/images/background-mountain.jpg\')'}">
          <div class="bg-overlay"></div>
        </div>
      </div>
    </v-fade-transition>

    <app-menu :show="isAuthorized"/>

    <transition name="menu-slide-from-bottom" mode="out-in">
      <div v-if="isAuthorized">
        <app-bar />
      </div>
    </transition>
    

    <v-content>
      <v-container fluid style="height: 100%;">
        <transition name="fade-up" mode="out-in" appear>
          <router-view v-if="showContent"></router-view>
        </transition>
      </v-container>
    </v-content>

    <v-footer
      inset
      app
      class="justify-end"
      v-if="isAuthorized"
    >
      <span class="px-4">Stayhealthy Inc. &copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import AppMenu from '@/components/AppMenu'
import AppBar from '@/components/AppBar'

export default {
  name: 'App',
  components: {
    'app-menu': AppMenu,
    'app-bar': AppBar
  },
  data: () => ({
    showContent: false
  }),
  mounted: function() {
    if(this.isAuthorized) {
      this.showContent = true;
    } else {
      setTimeout(() => {
        this.showContent = true;
      }, 200);
    }
  },
  computed: {
    isAuthorized: function() {
      return this.$store.getters.isAuthorized;
    }
  }
};
</script>

<style lang="scss">
  @import './assets/scss/_main.scss';
</style>
